import React, { useEffect } from "react";
import TotpReminder from "../pages/auth/Totp-Reminder";
import { Redirect, Route, Switch, withRouter, useLocation } from "react-router-dom";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { useLastLocation } from "react-router-last-location";
import * as auth from "../store/ducks/auth.duck";
import HomePageAdmin from "../pages/home/HomePageAdmin";
import HomePagePsychologist from "../pages/home/HomePagePsychologist";
import HomePageClient from "../pages/home/HomePageClient";
import HomePageCSClient from "../pages/home/HomePageCSClient";
import HomePageReferrer from "../pages/home/HomePageReferrer";
import HomePageCentralisedService from "../pages/home/HomePageCentralisedService";
import HomePageCentralisedServiceAdmin from "../pages/home/HomePageCentralisedServiceAdmin";
import ErrorsPage from "../pages/errors/ErrorsPage";
import LogoutPage from "../pages/auth/Logout";
// import PasswordUpdate from "../pages/auth/PasswordUpdate";
import { LayoutContextProvider } from "../../_metronic";
import Layout from "../../_metronic/layout/Layout";
import * as routerHelpers from "../router/RouterHelpers";
import AuthPage from "../pages/auth/AuthPage";
import ClientRegistrationPage from "../pages/registration/ClientRegistrationPage";
import { EAPRegistrationPage } from "../pages/registration/ClientRegistrationPage";
import { NDISRegistrationPage } from "../pages/registration/ClientRegistrationPage";
import PsychologistRegistrationPage from "../pages/registration/PsychologistRegistrationPage";
import PsychologistInvitationPage from "../pages/registration/PsychologistInvitationPage";
import ReferrerInvitationPage from "../pages/registration/ReferrerInvitationPage";
import SurveyAuthPage from "../pages/auth/SurveyAuth";
import FormAuthPage from "../pages/auth/FormAuth";
import EmailAuthPage from "../pages/auth/EmailAuth";
import { LicenseInfo } from "@mui/x-license-pro";

LicenseInfo.setLicenseKey("97cbd13c9ca1843df6f1a65216673c4bT1JERVI6NDM0MTAsRVhQSVJZPTE2ODM3ODI3NjYwMDAsS0VZVkVSU0lPTj0x");

export const Routes = withRouter(({ history }) => {
  const location = useLocation();
  const lastLocation = useLastLocation();
  const pathname = useLocation().pathname;
  routerHelpers.saveLastLocation(lastLocation);
  const { isAuthorized, menuConfig, isTotp, isForcePasswordChange, roleDesc, mfaConfigured, mfaReminderSkipped } = useSelector(
    ({ auth, urls, builder: { menuConfig } }) => ({
      menuConfig,
      isAuthorized: auth.authToken != null,
      isTotp: (auth.totp && auth.totp.length > 5 && auth.authToken === null) || false,
      isForcePasswordChange: (auth.forcePasswordChange && auth.forcePasswordChange === "1" && auth.authToken !== null) || false,
      roleDesc: auth.roleDesc === "" ? "Basic" : auth.roleDesc,
      mfaConfigured: auth.mfaConfigured === "Configured" || auth.mfaConfigured === "EmailMFA",
      mfaReminderSkipped: auth.mfaReminderSkipped || false,
      userLastLocation: routerHelpers.getLastLocation(),
    }),
    shallowEqual,
  );

  const dispatch = useDispatch();
  const centralisedService = useSelector((state) => state.auth.centralisedService);
  // Handle search query with login
  useEffect(() => {
    if (location.search) {
      dispatch(auth.actions.setSearchString(location.search));
    }
  }, [location.search, dispatch]);

  function roleCheckLayout() {
    // console.log('roleCheckLayout')
    // console.log(roleDesc)
    if (roleDesc === "Admin") {
      console.log("mfaConfigured:", mfaConfigured, "mfaReminderSkipped:", mfaReminderSkipped, "pathname:", pathname);
      if (!mfaConfigured && !mfaReminderSkipped && pathname !== "/auth/totp-reminder") {
        return <Redirect to="/auth/totp-reminder" />;
      }
      return (
        <Layout>
          <HomePageAdmin userLastLocation="/dashboard" />
        </Layout>
      );
    } else if (roleDesc === "Psychologist") {
      // console.log("mfaConfigured:", mfaConfigured, "mfaReminderSkipped:", mfaReminderSkipped, "pathname:", pathname);
      // if (!mfaConfigured && !mfaReminderSkipped && pathname !== "/auth/totp-reminder") {
      //   console.log("Redirecting to /auth/totp-reminder");
      //   return <Redirect to="/auth/totp-reminder" />;
      // }

      return (
        <Layout>
          <HomePagePsychologist userLastLocation="/dashboard" />
        </Layout>
      );
    } else if (roleDesc === "Referrer") {
      return (
        <Layout>
          <HomePageReferrer userLastLocation="/dashboard" />
        </Layout>
      );
    } else if (roleDesc === "CS") {
      // console.log("mfaConfigured:", mfaConfigured, "mfaReminderSkipped:", mfaReminderSkipped, "pathname:", pathname);
      // if (!mfaConfigured && !mfaReminderSkipped && pathname !== "/auth/totp-reminder") {
      //   console.log("Redirecting to /auth/totp-reminder");
      //   return <Redirect to="/auth/totp-reminder" />;
      // }
      return (
        <Layout>
          <HomePageCentralisedService userLastLocation="/dashboard" />
        </Layout>
      );
    } else if (roleDesc === "CSAdmin") {
      console.log("mfaConfigured:", mfaConfigured, "mfaReminderSkipped:", mfaReminderSkipped, "pathname:", pathname);
      if (!mfaConfigured && !mfaReminderSkipped && pathname !== "/auth/totp-reminder") {
        console.log("Redirecting to /auth/totp-reminder");
        return <Redirect to="/auth/totp-reminder" />;
      }
      return (
        <Layout>
          <HomePageCentralisedServiceAdmin userLastLocation="/dashboard" />
        </Layout>
      );
    } else {
      if (centralisedService === "1") {
        return (
          <Layout>
            <HomePageCSClient userLastLocation="/dashboard" />
          </Layout>
        );
      }
      return (
        <Layout>
          <HomePageClient userLastLocation="/dashboard" />
        </Layout>
      );
    }
  }

  return (
    /* Create `LayoutContext` from current `history` and `menuConfig`. */
    <LayoutContextProvider history={history} menuConfig={menuConfig}>
      <Switch>
        {/* Anonymous pages */}
        <Route path="/clientregistration/ndis" component={NDISRegistrationPage} />
        <Route path="/clientregistration/:invitetoken" component={ClientRegistrationPage} />
        <Route path="/providerregistration/:invitetoken" component={PsychologistRegistrationPage} />
        <Route path="/psychologistregistration/:invitetoken" component={PsychologistRegistrationPage} />
        <Route path="/eap/:eapToken?" component={EAPRegistrationPage} />
        <Route path="/psychologistinvitation/:programid?" component={PsychologistInvitationPage} />
        <Route path="/referrerinvitation" component={ReferrerInvitationPage} />
        <Route path="/survey" component={SurveyAuthPage} />
        <Route path="/form" component={FormAuthPage} />
        <Route path="/emailauth" component={EmailAuthPage} />

        {isTotp ? <Redirect from="/auth/login" to="/auth/totp" /> : null}

        {isAuthorized && mfaConfigured && <Redirect from="/auth/totp-reminder" to="/dashboard" />}

        {!isAuthorized ? <Route path="/auth" component={AuthPage} /> : <Route path="/auth/totp-reminder" component={AuthPage} />}

        {isAuthorized && <Redirect from="/auth" to="/dashboard" />}
        <Route path="/error" component={ErrorsPage} />
        <Route path="/logout" component={LogoutPage} />

        {!isAuthorized ? <Redirect to="/auth/login" /> : roleCheckLayout()}
      </Switch>
    </LayoutContextProvider>
  );
});
